import {VidstackPlayer, VidstackPlayerLayout} from 'vidstack/global/player';

import 'vidstack/player/styles/default/theme.css';
import 'vidstack/player/styles/default/layouts/video.css';

document.addEventListener('DOMContentLoaded', () => {
    initPlayers();
})


function initPlayers() {
    const videos = document.getElementsByClassName('vid-wrapper');
    // console.log(videos);
    for (let i = 0; i < videos.length; i++) {
        const videoElement = videos[i];
        createOneVideo(videoElement).then(e => {
            console.log(e);
        });
    }
}

async function createOneVideo(videoElement) {
    console.log(videoElement)
    let props = {
        target: videoElement,
        layout: new VidstackPlayerLayout({})
    };
    if (videoElement.dataset.hasOwnProperty('yt')) {
        props.src = 'youtube/' + videoElement.dataset.yt;
        props.poster = 'https://img.youtube.com/vi/' + videoElement.dataset.yt + '/maxresdefault.jpg';
    }

    const player = await VidstackPlayer.create(props);
}